module.exports = __webpack_public_path__ + "img/public.70987981.jpg";